export function valid() {
  return {valid: true}
}

export function invalid(message) {
  return {valid: false, message}
}
